import React from 'react'
import ProductListContainer from '../../../../Components/Applications/ECommerce/ProductList'

export default function ProductList() {
  return (
    <div className='page-body'>
      <ProductListContainer />
    </div>
  )
}